
import React, {ReactNode} from 'react';
import {SwipeableHandlers} from 'react-swipeable';

import {Factoid} from './Screens/Factoid';
import {Feedback} from './Screens/Feedback';
import {Info} from './Screens/Info';
import {Intro} from './Screens/Intro';
import {Positioner} from './Screens/Screen';
import {StateConfig, StateProvider} from './context';
import {ScreenConfig} from './types';

const swipeDelay = (screen: ScreenConfig) => {
	const DEFAULT_DURATION_MS = 7000;

	if (screen.type === 'intro') {
		return -1;
	} else if (screen.type === 'info') {
		return 4000;
	}

	return DEFAULT_DURATION_MS;
};

export const render = (config: StateConfig, handlers: SwipeableHandlers): ReactNode => {
	const active = config.state.screens[config.state.index]?.id;
	return config.state.actives.map((screen, index) => {
		if (!screen) {
			return <Positioner key={index} />;
		}

		// Configure per-screen context
		const updated: StateConfig = {
			...config,

			// Pass in screen where available
			screen,

			// Special configs for active screens
			...(screen.id === active ? {
				active: true,
				swipes: handlers,
				sdelay: swipeDelay(screen),
			} : {}),
		};

		// Dynamically set the screen to render
		let Screen = Factoid;
		if (screen.type === 'intro') {
			Screen = Intro;
		} else if (screen.type === 'feedback') {
			Screen = Feedback;
		} else if (screen.type === 'info') {
			Screen = Info;
		}

		return (
			<StateProvider config={updated} key={screen.id}>
				<Screen key={screen.id} {...screen.props} />
			</StateProvider>
		);
	});
};
